import gql from "graphql-tag";

export const LedgerAccounting = gql`
  query slLocationLedgerAccounts($location: String!, $limit:Int!, $offset:Int!) {
    slLocationLedgerAccounts(location: $location, limit:$limit, offset:$offset) {
      totalItems
      data
    }
  }
`;
export const LedgerAccountingRoll = gql`
  query slLocationLedgerAccounts($location: String!, $limit:Int!, $offset:Int!) {
    slLocationLedgerAccounts(location: $location, limit:$limit, offset:$offset) {
      totalItems
      data
    }
  }
`;



export const AccountingMetrics = gql`
  query slMetrics($location: String!) {
    slMetrics(location: $location) {
      edges {
        node {
          id
          locationId
          invoicesPaid30
          invoicesUnpaid30
          invoicesTotal30
          invoicesPaid365
          invoicesUnpaid365
          invoicesTotal365
          expensesTotal30
          expensesTotal365
          assetsTotal365
          assetsTotal30
          incomeTotal30
          incomeTotal365
          netIncomeTotal30
          netIncomeTotal365
          createdAt
          updatedAt
          incomeTotalGraph
          expensesTotalGraph
          invoicesTotalGraph
        }
      }
    }
  }
`;

export const SingleLedgerAccounting = gql`
  query slLocationAccountTransactions(
    $location: String!
    $LedgerAccountId: Int!
    $startDate: Date!
    $endDate: Date!
  ) {
    slLocationAccountTransactions(
      location: $location
      LedgerAccountId: $LedgerAccountId
      startDate: $startDate
      endDate: $endDate
    ) {
      totalItems
      startingBalance
      data
    }
  }
`;

export const TransAccounting = gql`
  query slLocationTransactions($location: String!, $limit:Int!, $offset:Int!) {
    slLocationTransactions(location: $location, limit:$limit, offset:$offset) {
      totalItems
      startingBalance
      data
    }
  }
`;

export const ChargeAccounting = gql`
  query chargeCodes($location: String!) {
    chargeCodes(location: $location) {
      edges {
        node {
          id
          name
          quantity
          desc
          extLedgerId
          locationId
          extTaxcodeId
          amountDefault
          descInternal
          code
          type
    
        }
      }
    }
  }
`;

export const DefaultChargeCodes = gql`
  query defaultChargeCodes($locationId: String!) {
    defaultChargeCodes(locationId: $locationId) {
      edges {
        node {
          unitChargeCode {
            id
            name
            code
            amountDefault
            quantity
          }
          petChargeCode {
            id
            name
            code
            amountDefault
            quantity
          }
          vehicleChargeCode{
            id
            name
            code
            amountDefault
            quantity
          }
          depositChargeCode{
            id
            name
          }
        }
      }
    }
  }
`;

export const ChargeAccountingMutation = gql`
  mutation createChargeCode($input: CreateChargeCodeInput!) {
    createChargeCode(accounting: $input) {
      response
      chargeCode
    }
  }
`;

export const ReconcileData = gql`
  query slLocationTransactions($location: String!, $ledger: String!, $start: String!, $end: String!,$limit:Int!, $offset:Int!) {
    slLocationTransactions(location: $location, ledger:$ledger,start:$start,end:$end, limit:$limit, offset:$offset) {
      totalItems
      startingBalance
      data
    }
  }
`;
export const ReconcileSumData = gql`
  query slSumLocationAccount($location: String!, $ledger: String!, $start: String!, $end: String!) {
    slSumLocationAccount(location: $location, ledger:$ledger,start:$start,end:$end) 
      
  }
`;
export const LocationJournal = gql`
  query slLocationAccountJournal($location: String!, $journal: String!) {
    slLocationAccountJournal(location: $location, journal:$journal) 
      
  }
`;

export const UpdateAccountingMutation = gql`
  mutation updateChargeCode($input: UpdateChargeCodeInput!) {
    updateChargeCode(accounting: $input) {
      response
      chargeCode
    }
  }
`;
export const DeleteAccountingMutation = gql`
  mutation deleteChargeCode($input: DeleteChargeCodeInput!) {
    deleteChargeCode(accounting: $input) {
      response
    }
  }
`;

export const CreateLedgerMutation = gql`
  mutation createSlLedgerAccount($input: CreateSLLedgerAccountInput!) {
    createSlLedgerAccount(accounting: $input) {
      response
      slLedgerAccount
    }
  }
`;
export const UpdateLedgerMutation = gql`
  mutation updateSlLedgerAccount($input: UpdateSLLedgerAccountInput!) {
    updateSlLedgerAccount(accounting: $input) {
      response
      slLedgerAccount
    }
  }
`;
export const DeleteLedgerMutation = gql`
  mutation deleteSlLedgerAccount($input: DeleteSLLedgerAccountInput!) {
    deleteSlLedgerAccount(accounting: $input) {
      response
    }
  }
`;

export const InvoiceAccounting = gql`
  query slLocationInvoices($location: String!, $limit:Int!, $offset:Int!, $credits:Boolean!) {
    slLocationInvoices(location: $location, limit:$limit, offset:$offset, credits: $credits) {
      totalItems
      data
    }
  }
`;

export const SLInvoiceAccounting = gql`
  query slLocationInvoice($location: String!,$id: Int!) {
    slLocationInvoice(location: $location, id:$id) {
      invoice
    }
  }
`;

export const BillsAccounting = gql`
  query slLocationBills($location: String!, $status:[String!] ) {
    slLocationBills(location: $location, status:$status) 
  }
`;
export const BillAccounting = gql`
  query slLocationBills($location: String!, $status:[String!], $BillId: Int!) {
    slLocationBills(location: $location, status:$status, BillId:$BillId) 
  }
`;

export const VendorsAccounting = gql`
  query slLocationVendors($location: String!) {
    slLocationVendors(location: $location) 
  }
`;

export const slLocationInvoicePayments = gql`
  query slLocationInvoicePayments($location: String!, $InvoiceId: Int!) {
    slLocationInvoicePayments(location: $location, InvoiceId: $InvoiceId ) 
  }
`;

export const slLocationInvoiceTransactions = gql`
  query slLocationTransactions($location: String!, $InvoiceId: Int!) {
    slLocationTransactions(location: $location, InvoiceId: $InvoiceId ) {
      totalItems
      startingBalance
      data
    }
  }
`;

export const paySlInvoice = gql`
  mutation paySlInvoice($input: PaySLInvoiceInput!) {
    paySlInvoice(accounting: $input) {
      response
    }
  }
`;

export const PaymentAccounting = gql`
  query slLocationPayments($location: String!, $limit:Int!, $offset:Int!) {
    slLocationPayments(location: $location, limit:$limit, offset:$offset) {
      totalItems
      data
    }
  }
`;

export const transactionsGql = gql`
   query slLocationTransactions($location: String!, $limit:Int!, $offset:Int!) {
    slLocationTransactions(location: $location, limit:$limit, offset:$offset) {
      totalItems
      startingBalance
      data
    }
  }
`;
export const financialsGql = gql`
   query slLocationFinancials($location: String!, $reportType: String!, $start:String!, $end:String!) {
    slLocationFinancials(location: $location, reportType:$reportType, start:$start,end:$end) 
  }
`;
export const trialGql = gql`
   query slLocationTrialBalance($location: String!, $numType: Int!, $journalStatus:String!, $dateType:String!) {
    slLocationTrialBalance(location: $location, numType:$numType, journalStatus:$journalStatus,dateType:$dateType) 
  }
`;

export const InvoiceInfoAccounting = gql`
  query slLocationInvoice($location: String!, $id: Int!) {
    slLocationInvoice(location: $location, id: $id) {
      location {
        name
        contact
        addresses {
          zip
          state
          street
          city
        }
      }
      customer {
        nameUpper
        email
        addresses {
          zip
          state
          street
          city
        }
      }
      payments
      invoice {
        number
        status
        currency
        invoiceDate
        dueDate
        subtotal
        tax
        amount
      }
      items {
        subtotal
        total
        taxAmount
        description
        quantity
      }
      service {
        type
        service
      }
    }
  }
`;

export const customersAccounting = gql`
  query slCustomers($location: String!) {
    slCustomers(location: $location) {
      totalItems
      data
    }
  }
`;

export const CreateInvoiceMutation = gql`
  mutation createSlInvoice($input: CreateSLInvoiceInput!) {
    createSlInvoice(accounting: $input) {
      response
      slInvoice
    }
  }
`;
export const UpdateInvoiceMutation = gql`
  mutation updateSlInvoice($input: UpdateSLInvoiceInput!) {
    updateSlInvoice(accounting: $input) {
      response
    }
  }
`;

export const DeleteInvoiceMutation = gql`
  mutation deleteSlInvoice($input: DeleteSLInvoiceInput!) {
    deleteSlInvoice(accounting: $input) {
      response
    }
  }
`;
export const VoidInvoiceMutation = gql`
  mutation voidSlInvoice($input: SLInvoiceInput!) {
    voidSlInvoice(accounting: $input) {
      response
    }
  }
`;
export const IssueInvoiceMutation = gql`
  mutation issueSlInvoice($input: SLInvoiceInput!) {
    issueSlInvoice(accounting: $input) {
      response
    }
  }
`;

export const TaxAccounting = gql`
  query slLocationTaxCodes($location: String!, $limit:Int!, $offset:Int!) {
    slLocationTaxCodes(location: $location, limit:$limit, offset:$offset) {
      totalItems
      data
    }
  }
`;
export const TaxAccountingRoll = gql`
  query slLocationTaxCodes($location: String!, $limit:Int!, $offset:Int!) {
    slLocationTaxCodes(location: $location, limit:$limit, offset:$offset) {
      totalItems
      data
    }
  }
`;

export const RentRollGQL = gql`
  query rentRoll($locationId: String!) {
    rentRoll(locationId: $locationId) 
  }
`;
export const TaxCreateMutation = gql`
  mutation createSlTaxCode($input: CreateSLTaxCodeInput!) {
    createSlTaxCode(accounting: $input) {
      response
      slTaxCode
    }
  }
`;

export const TaxUpdateMutation = gql`
  mutation updateSlTaxCode($input: UpdateSLTaxCodeInput!) {
    updateSlTaxCode(accounting: $input) {
      response
      slTaxCode
    }
  }
`;

export const TaxDeleteMutation = gql`
  mutation deleteSlTaxCode($input: DeleteSLTaxCodeInput!) {
    deleteSlTaxCode(accounting: $input) {
      response
    }
  }
`;

export const ManagerInvoice = gql`
  query invoiceCustomers($locationId: String!) {
    invoiceCustomers(locationId: $locationId) {
      name
      agentId
      referenceId
    }
  }
`;

export const RepayMutation = gql`
mutation revertTransaction($transaction: RevertTransactionInput!) {
  revertTransaction(transaction: $transaction) {
    response
  }
}
`


export const VendorCreateMutation = gql`
  mutation createSlVendor($input: CreateSLVendorInput!) {
    createSlVendor(accounting: $input) {
      response
    }
  }
`;

export const BillCreateMutation = gql`
  mutation createSlBill($input: CreateSLBillInput!) {
    createSlBill(accounting: $input) {
      response
    }
  }
`;

export const BoxScoreGql = gql`
   query boxScoreResults($locationId: String!, $startDate:Date!, $endDate:Date!, $reportType:ReportTypes!) {
    boxScoreResults(locationId: $locationId, startDate:$startDate,endDate:$endDate, reportType:$reportType) {
      edges {
        cursor
        node {
          id
          unit
          floorPlan
          name
          applyDate
          moveIn
          leaseTerm
          marketRent
          leaseRent
          credits
          otherCharges
          depositOnhand
          leasedBy
          effectiveRent
        }
      }
    }
  }
`;

export const approveSLBillMutation = gql`
  mutation approveSlBill($input: ApproveSLBillInput!) {
    approveSlBill(accounting: $input) {
      response
    }
  }
`;
export const deleteSLBillMutation = gql`
  mutation deleteSlBill($input: DeleteSLBillInput!) {
    deleteSlBill(accounting: $input) {
      response
    }
  }
`;
export const voidSLBillMutation = gql`
  mutation voidSlBill($input: VoidSLBillInput!) {
    voidSlBill(accounting: $input) {
      response
    }
  }
`;

export const paySLBillMutation = gql`
  mutation paySlBill($input: PaySLBillInput!) {
    paySlBill(accounting: $input) {
      response
    }
  }
`;
export const updateSLBillMutation = gql`
  mutation updateSlBill($input: UpdateSLBillInput!) {
    updateSlBill(accounting: $input) {
      response
    }
  }
`;

export const slLocationBillPayments = gql`
  query slLocationBillPayments($location: String!, $BillId: Int!) {
    slLocationBillPayments(location: $location, BillId: $BillId ) 
  }
`;
export const slLocationTransactions = gql`
  query slLocationTransactions($location: String!, $BillId: Int!) {
    slLocationTransactions(location: $location, BillId: $BillId ) {
      totalItems
      startingBalance
      data
    }
  }
`;
export const approveSLPaymentToBillMutation = gql`
  mutation approveSlBillPayment($input: ApproveSLBillPaymentInput!) {
    approveSlBillPayment(accounting: $input) {
      response
    }
  }
`;
export const voidSLPaymentToBillMutation = gql`
  mutation voidSlBillPayment($input: VoidSLBillPaymentInput!) {
    voidSlBillPayment(accounting: $input) {
      response
    }
  }
`;
export const deleteSLPaymentToBillMutation = gql`
  mutation deleteSlBillPayment($input: DeleteSLBillPaymentInput!) {
    deleteSlBillPayment(accounting: $input) {
      response
    }
  }
`;
